// src/hooks/countries/useUpdateCountries.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateCountry } from "../../api/apiCountries";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

const useUpdateCountries = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate()
    const {
        mutate: editCountries,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: ({ id, req }) => updateCountry(req, id),
        onSuccess: (response) => {
            toast.success(response?.message);
            navigate('/countries');
            queryClient.invalidateQueries({ queryKey: ["countries"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update country");
        },
    });

    return {
        editCountries,
        isUpdate: isPending || isLoading,
    };
};

export default useUpdateCountries;
